const TripAdvisor = () => {
  const a = String(Math.floor(Math.random() * 10000000000000000));
  return a ? (
    <img
      src={`https://pubads.g.doubleclick.net/activity;xsp=4863243;ord=${a}?`}
    />
  ) : (
    <img
      src="https://pubads.g.doubleclick.net/activity;xsp=4863243;ord=1?"
      width={1}
      height={1}
      border={0}
    />
  );
};

export default TripAdvisor;
